import script from "./StructureWorkerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureWorkerComponent.vue?vue&type=script&setup=true&lang=js"

import "./StructureWorkerComponent.vue?vue&type=style&index=0&id=624a182a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624a182a"]])

export default __exports__